/**
 * Created by Arif Topcu in 2019
 */

import React, {memo, useCallback} from 'react';
import PropTypes from 'prop-types';
import Icon from 'react-icons-kit';
import {ic_add} from 'react-icons-kit/md/ic_add';
import {ic_clear} from 'react-icons-kit/md/ic_clear';
import {ic_content_copy} from 'react-icons-kit/md/ic_content_copy';
import styles from './GroupingComplicationSelector.module.css';
import Button from "@ls/react-button";
import ExpandingSelectorWindow from '@ls/expanding-selector-window';

const iconStyle = {color: '#464646'};

const DefinitionDetail = memo(({setDefinition, idx, complicationTitle, ComplicationComponent, definition, size}) => {
  const onSetDefinition = useCallback((def) => setDefinition(idx, def), [idx, setDefinition]);
  const onDeleteDefinition = useCallback(() => setDefinition(idx, null), [idx, setDefinition]);
  const onCopyDefinition = useCallback(() => setDefinition(size, definition), [setDefinition, definition, size]);
  return (
    <div className={styles.root} key={idx}>
      <div className={styles.top}>
        {complicationTitle && (
          <div className={styles.title}>
            {complicationTitle} {size > 1 ? (idx + 1) : ''}
          </div>
        )}
        <div className={styles.buttons}>
          <div className={styles.copy}>
            <Button
              icon={<Icon icon={ic_content_copy} size={15} style={iconStyle}/>}
              size="S"
              tooltip="Append a copy"
              ttPos={"left"}
              onButtonClick={onCopyDefinition}
              variation={5}
            />
          </div>
          <Button
            icon={<Icon icon={ic_clear} size={16} style={iconStyle}/>}
            size="S"
            onButtonClick={onDeleteDefinition}
            variation={5}
          />
        </div>
      </div>
      <div className={styles.fields}>
        <ComplicationComponent
          definition={definition}
          setDefinition={onSetDefinition}
        />
      </div>
    </div>
  );
});

const ComplicationSelector = ({ selectedDefinitions,
                                setDefinition,
                                getDefaultDefinition,
                                ComplicationComponent,
                                btnTitle,
                                complicationTitle,
                                addMoreText }) => {

  const size = selectedDefinitions ? selectedDefinitions.length : 0;

  return (
    <ExpandingSelectorWindow
      title={btnTitle}
      size={size}
    >
      {selectedDefinitions.map((definition, idx) => (
        <DefinitionDetail
          key={idx}
          idx={idx}
          definition={definition}
          setDefinition={setDefinition}
          complicationTitle={complicationTitle}
          ComplicationComponent={ComplicationComponent}
          size={size}
        />
      ))}
      <div
        className={styles.addMoreBtn}
        onClick={() => setDefinition(size, getDefaultDefinition())}>
        <Icon icon={ic_add} style={{display: 'flex', alignItems: 'center'}}/>
        <div className={styles.addMoreText}>Add {addMoreText || complicationTitle}</div>
      </div>
    </ExpandingSelectorWindow>
  );
};

ComplicationSelector.propTypes = {
  selectedDefinitions: PropTypes.array.isRequired,
  setDefinition: PropTypes.func.isRequired,
  getDefaultDefinition: PropTypes.func.isRequired,
  ComplicationComponent: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
  btnTitle: PropTypes.string.isRequired,
  complicationTitle: PropTypes.string,
  addMoreText: PropTypes.string,
};

export default memo(ComplicationSelector);
